import { BlogSection } from '@/types/blog';

export const fazit: BlogSection = {
  id: 'fazit',
  title: 'Den Hebel dort ansetzen, wo es zählt',
  content: `
<p>Wenn Sie das Gefühl haben, gegen eine unsichtbare Wand zu laufen, ist das kein Zeichen von Schwäche. Es ist ein Signal Ihres Systems, dass die Bedingungen für eine sichere Entscheidung gerade nicht optimal sind.</p>

<p>Lassen Sie uns in einem <a href="/kontakt" rel="noopener">ersten Gespräch</a> klären, wo genau der Hebel angesetzt werden muss. Ohne Druck, mit Expertise und dem Blick für das Wesentliche.</p>

<h3>Thematische Vertiefung & Angebote</h3>
<ul>
  <li><a href="/blog/hochsensible-fuehrung" rel="noopener">Führung als hochsensibler Mensch: Warum feine Wahrnehmung wertvoll sein kann</a></li>
  <li><a href="/blog/koerper-fuehrung" rel="noopener">Körper & Führung: Warum körperliche Intelligenz zählt</a></li>
  <li><a href="/blog/fuehrung-2026-haltung-empathie" rel="noopener">Führung 2026: Haltung, Empathie & der Mut zur Klarheit</a></li>
  <li><a href="/blog/betriebssystem-v5-2" rel="noopener">Betriebssystem v5.2: Frameworks für bewusste Entscheidungen</a></li>
  <li><a href="/executive-coaching" rel="noopener">Executive Coaching – Begleitung für Führungskräfte</a></li>
</ul>
  `
};
